<template>
  <club-layout>
    <player-info-blue-panel
      :code="code"
      :balance="balance"
      :insurance="insurance"
      :description="description"
    />
    <div id="container">
      <table-blue-player-events :events="events" />
    </div>
  </club-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import utils from '../../utils';
  import PlayerInfoBluePanel from './panels/PanelBlue/PanelBluePlayerInfo';
  import TableBluePlayerEvents from './tables/TableBluePlayerEvents';

  export default {
    name: "PlayerEventsPage",
    components: {
      PlayerInfoBluePanel,
      TableBluePlayerEvents,
    },
    computed: {
      ...mapGetters(['players']),
    },
    methods: {
      ...mapActions(['getInvoiceEvents']),
    },
    data() {
      return {
        skip: 0,
        code: null,
        events: null,
        balance: null,
        insurance: null,
        description: null,
      }
    },
    async created() {
      const { id } = this.$route.params;
      const [player] = this.players.filter(player => player.playerId === id);
      const response = await this.getInvoiceEvents({ playerId: id });
      this.code = player.code;
      this.events = response.events;
      this.balance = player.balance;
      this.insurance = player.insurance;
      this.description = player.description;

      document.title = utils.formatInvoice(this.code);
    },
    destroyed() {
      document.title = 'Plus';
    }
  }
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }
</style>
